
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webviews/rewards-terms",
      function () {
        return require("private-next-pages/webviews/rewards-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webviews/rewards-terms"])
      });
    }
  